import { IDictionary, IKeyedCollection } from '../../share/interfaces/idictionary';
import { IKeyvalue } from '../../share/interfaces';

export class KeyValuPair<V> implements IKeyvalue {
    Key: any;
    Value: V;
    constructor(key: any, value: V) {
        this.Key = key;
        this.Value = value;
    }
}

export class KeyStringValuePair<V> implements IKeyvalue {
    Key: string;
    Value: V;
    constructor(key: string, value: V) {
        this.Key = key;
        this.Value = value;
    }
}

export class CDictionary<V> implements IDictionary {
    _keys: any[] = [];
    _values: V[] = [];
    length: number = 0;

    addRange(KeyValuPairs: KeyValuPair<V>[]) {
        // KeyValuPairs
        for (let x = 0; x < KeyValuPairs.length; x++) {
            this[KeyValuPairs[x].Key] = KeyValuPairs[x].Value;
            this._keys.push(KeyValuPairs[x].Key);
            this._values.push(KeyValuPairs[x].Value);
        }
        this.length = KeyValuPairs.length;
    }

    add(key: any, value: any) {
        this[key] = value;
        this._keys.push(key);
        this._values.push(value);
        this.length++;
    }


    remove(key: any) {
        let index = this._keys.indexOf(key, 0);
        this._keys.splice(index, 1);
        this._values.splice(index, 1);

        delete this[key];
        this.length--;
    }

    clear() {
        this._keys.forEach(k => this.remove(k));
    }

    keys(): any[] {
        return this._keys;
    }

    values(): any[] {
        return this._values;
    }

    containsKey(key: any) {
        if (typeof this[key] === undefined) {
            return false;
        }
        return true;
    }

    toLookup(): IDictionary {
        return this;
    }

    Count(): number {
        return this.length;
    }
}

export class KeyedCollection<T> implements IKeyedCollection<T> {
    private items: { [index: string]: T } = {};

    private count: number = 0;

    public ContainsKey(key: string): boolean {
        return this.items.hasOwnProperty(key);
    }

    public Count(): number {
        return this.count;
    }

    public Add(key: string, value: T) {
        this.items[key] = value;
        this.count++;
    }

    public Remove(key: string): T {
        let val = this.items[key];
        delete this.items[key];
        this.count--;
        return val;
    }

    public Item(key: string): T {
        return this.items[key];
    }

    public Keys(): string[] {
        let keySet: string[] = [];

        for (let prop in this.items) {
            if (this.items.hasOwnProperty(prop)) {
                keySet.push(prop);
            }
        }

        return keySet;
    }

    public Values(): T[] {
        let values: T[] = [];

        for (let prop in this.items) {
            if (this.items.hasOwnProperty(prop)) {
                values.push(this.items[prop]);
            }
        }

        return values;
    }
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/classes/c-dictionary.ts